export enum EntityStoreKey {
  TellentGrantAccess = 'tellentGrantAccess',
}
